import React from "react";

function NotFound() {
  return (
    <div>
      <h1>Not Found</h1>
      <p>The page you are loaking for not exists</p>
    </div>
  );
}

export default NotFound;
